import block from "bem-cn";
import React, { useState } from "react";
import './InputField.scss';

const b = block("InputField");

type Props = {
  text?: string;
  onHandleChange?: Function;
  isRequired?: boolean;
  isReadOnly?: boolean;
  refInput?: React.MutableRefObject<HTMLInputElement>;
  inputValue?: number;
  placeholder?: string;
  type?: string;
};

const InputField = (props: Props) => {
  const {
    text = undefined,
    onHandleChange,
    isRequired = false,
    isReadOnly = false,
    refInput,
    inputValue = undefined,
    placeholder = 'placeholder',
    type = 'text'
  } = props;

  const [value, setValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onHandleChange && onHandleChange(e.target.value);
  }

  return (
    <label className={b()}>
      {text && <span className={b('caption')}>{text}</span>}
      <input placeholder={placeholder} ref={refInput} readOnly={isReadOnly} required={isRequired} type={type} className={b("input")} value={inputValue === undefined ? value : inputValue} onChange={handleChange} />
    </label>
  );
};

export default InputField;
